// extracted by mini-css-extract-plugin
export default {"containter":"first_containter__y0+M+","icon":"first_icon__GGiSK"};